import React from 'react';
import GridBackground from './GridBackground';

const exchanges = [
  {
    name: 'PROBIT',
    url: 'https://www.probit.com/app/exchange/GOL-BTC',
    img: 'https://winio.conext.click/api/v1/buckets/goldofir/objects/download?preview=true&prefix=website%2Fprobit-review.png.webp&version_id=null',
  },
  {
    name: 'SushiSwap',
    url: 'https://www.sushi.com/polygon/swap?token0=0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619&token1=0xa1B7797F97eE6C928A6Ce0E403f345b68945C6D7',
    img: 'https://winio.conext.click/api/v1/buckets/goldofir/objects/download?preview=true&prefix=website%2FSushiswap.png&version_id=null',
  },
];

const Hero = () => {
  return (
    <section className="hero-modern hero-21st">
      <div className="hero-bg-animated" aria-hidden="true"></div>
      <GridBackground />
      <div className="container hero-21st-container">
        <div className="hero-21st-content">
          <h1 className="hero-title animate-fade-in">TOKEN FGOL</h1>
          <p className="hero-subtitle animate-slide-up">
            Utility Token to foment Startups and promising business opportunities,<br />
            developed within a highly scalable growth model.
          </p>
          <div className="whitepaper-links hero-21st-actions">
            <a
              href="https://drive.google.com/file/d/1SEmUD7SYKRgi9w63nPvH-z2Z6jAQ-qXG/view?usp=drive_link"
              className="modern-btn hero-21st-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              Whitepaper EN
            </a>
            <a
              href="https://drive.google.com/file/d/1NHn383Y_53A_03m5NADYULyQ3x8WKH5W/view?usp=drive_link"
              className="modern-btn hero-21st-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              Whitepaper PT
            </a>
          </div>
          <div className="hero-21st-trade">
            <span className="hero-21st-trade-label">TRADE ON</span>
            <div className="hero-21st-exchanges">
              {exchanges.map((ex, idx) => (
                <a
                  key={ex.name}
                  href={ex.url}
                  className="hero-21st-exchange-card"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={ex.img} alt={ex.name} />
                  <span>{ex.name}</span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
